/*eslint-disable no-console*/
// import _ from 'lodash'
import thunk from 'redux-thunk'
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { routerReducer, routerMiddleware } from 'react-router-redux'
// import { createTransform, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // default: localStorage if web, AsyncStorage if react-native

import logger from 'redux-logger'

const composeEnachers = (
  process.env.NODE_ENV !== 'production' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
  }) : compose )


// const logger = store => next => action => {
//   console.group(action.type)
//   console.info('dispatching', action)

//   let result = next(action)

//   console.log('next state', store.getState())
//   console.groupEnd(action.type)

//   return result
// }

// persist config
const apiConfig = {
  key: 'persistedApi',
  storage: storage,
  blacklist: ['_jobs', 'auth']
}
const preferencesConfig = {
  key: 'preferences',
  storage: storage
}


export const combinedReducers = (apiReducer, history) => {
  return combineReducers({
    //api: persistReducer(apiConfig, apiReducer),
    api: apiReducer,
    router: routerReducer(history)
  })
}

export const configureStore = (apiReducer, preloadedState, history, ...extraMiddlewers) => {
  return createStore(
    combinedReducers(apiReducer, history),
    preloadedState,
    composeEnachers(applyMiddleware(
      thunk, routerMiddleware(history), logger,
      ...extraMiddlewers)))
}



// WEBPACK FOOTER //
// ./src/store.js